const { getElement, getElements } = window.BAO.Utils

export class ProductEngraving extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.regex = /^[a-zA-Z0-9!?&.+\-/ ]*$/
    this.svgs = []
    this.logos = []
    this.textContainerGroups = []

    try {
      this.engravingProps = JSON.parse(this.dataset.engravingProps)
    } catch {
      this.engravingProps = [
        {
          x: 200,
          y: 200,
          fs: 30,
        },
      ]
    }

    this.colourSelect = getElement('[data-product-colours-select]')

    this.els.image.elements.forEach((container) => {
      this.createOverlayElements(container)
    })
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this.els.available.element, 'change', () => {
      this.engravingProps.forEach((prop, index) => {
        this.updateOverlayText(index).bind(this)
      })
    })
    this.els.line.elements.forEach((line) => {
      this.listeners.add(line, 'keyup', this.onLineChange.bind(this))
      this.listeners.add(line, 'paste', this.onLinePaste.bind(this))
      this.listeners.add(line, 'change', this.onLineChange.bind(this))
    })
    this.listeners.add(this.colourSelect, 'change', (e) => {
      this.svgs.forEach((svg) => {
        svg.dataset.colour = e.target.value.toLowerCase()
      })
      this.logos.forEach((logo) => {
        logo.dataset.colour = e.target.value.toLowerCase()
      })
    })
    this.els.font.elements.forEach((font) => {
      this.listeners.add(font, 'change', this.onFontChange.bind(this))
    })
    this.els.form.elements.forEach((form) => {
      this.listeners.add(form, 'submit', this.formSubmit.bind(this))
    })

    if (this?.els?.style?.exists) {
      this.els.style.elements.forEach((style) => {
        this.listeners.add(style, 'change', this.onStyleToggle.bind(this))
      })
    }

    this.changeVariant = this.changeVariant.bind(this)
    this.listeners.add(document, 'colourSwitch', this.changeVariant)
  }

  changeVariant (e) {
    const colour = e.detail.value

    this.els.image.elements.forEach((engravingImage) => {
      engravingImage.setAttribute(
        'aria-current',
        engravingImage.dataset.colour === colour.toLowerCase(),
      )
    })

    const engravingVariant = getElement('[data-engraving-variant]')
    const item = getElements('option', { context: engravingVariant }).find(
      (option) => {
        return option.innerText.toLowerCase() === colour.toLowerCase()
      },
    )
    if (item) {
      engravingVariant.value = item.value
    }

    getElement('[data-engraving-variant-id]').value = engravingVariant.value
  }

  createOverlayElements (container) {
    this.svgNS = 'http://www.w3.org/2000/svg'

    const svgContainer = document.createElement('div')
    svgContainer.classList.add('prd-Engraving_Overlay')
    container.appendChild(svgContainer)

    const svg = document.createElementNS(this.svgNS, 'svg')
    svg.classList.add('prd-Engraving_OverlayCanvas')
    svg.dataset.colour = this.colourSelect.value.toLowerCase()
    svg.style.fontFamily = this.els.font.element.value
    svg.setAttribute('viewBox', '0 0 400 400')
    svgContainer.appendChild(svg)

    const charmTextContainers = []
    this.engravingProps.forEach(() => {
      const textContainer = document.createElementNS(this.svgNS, 'g')
      svg.appendChild(textContainer)
      charmTextContainers.push(textContainer)
    })

    this.svgs.push(svg)
    this.textContainerGroups.push(charmTextContainers)

    this.createLogoOverlay(container)
  }

  createLogoOverlay (container) {
    const logoSvgs = getElements('.prd-Engraving_OverlayCanvas', {
      context: container,
    })
    const logoContainer = this.els.imagecontainer.element
    const logoTop = parseInt(logoContainer.dataset.logoTop)
    const logoLeft = parseInt(logoContainer.dataset.logoLeft)
    const logoScale = logoContainer.dataset.logoScale || 1
    const selectedColour = container.dataset.colour

    logoSvgs.forEach((logoSvg) => {
      logoSvg.dataset.colour = selectedColour
      const path = logoSvg.querySelector('path')
      if (!path || !logoLeft || !logoTop || !logoScale) return
      path.setAttribute(
        'transform',
        `translate(${logoLeft},${logoTop}),scale(${logoScale})`,
      )
    })
  }

  onStyleToggle (e) {
    const logos = this.els.overlaycontainer.elements
    const style = e.target

    logos.forEach((logo) => {
      logo.style.display = 'none'
    })

    const isLogo = style.checked && style.value === 'logo'

    this.els.text.element.setAttribute('aria-hidden', isLogo)

    getElements('.prd-Engraving_Overlay').forEach((text) => {
      text.style.display = isLogo ? 'none' : 'block'
    })

    this.els.line.elements.forEach((line, index) => {
      line.name = isLogo ? '' : `properties[Engraving_Line_${index}]`
    })

    this.els.font.elements.forEach((font) => {
      font.name = isLogo ? '' : 'properties[Engraving_Line_Font]'
    })

    this.els.logoFont.element.name = isLogo
      ? 'properties[Engraving_Line_Font]'
      : ''
    this.els.logoLine.element.name = isLogo
      ? 'properties[Engraving_Line_1]'
      : ''

    style.checked
      ? this.els.action.element.setAttribute('aria-hidden', 'false')
      : this.els.action.element.setAttribute('aria-hidden', 'true')

    if (isLogo) {
      const engravingImages = this.els.image.elements

      engravingImages.forEach((container) => {
        const currentLogo = getElement('.prd-Engraving_OverlayContainer', {
          context: container,
        })
        if (currentLogo) {
          currentLogo.style.display = 'block'
        }
      })
    }
  }

  onFontChange (e) {
    this.svgs.forEach((svg) => {
      svg.style.fontFamily = e.target.value
    })
  }

  onLinePaste (e) {
    window.setTimeout(() => {
      e.target.dispatchEvent(new Event('change'))
    }, 1)
  }

  onLineChange (e) {
    const { target } = e

    if (target.value.length > target.maxLength) {
      target.value = target.value.substring(0, target.maxLength)
    }

    let tooltip = getElement('.prd-EngravingLine_Error', {
      context: target.parentElement,
    })

    this.toggleFormError(false, e.target.dataset.charmIndex)

    if (target.value.length !== 0) {
      target.classList.add('prd-EngravingLine_Value-active')
    } else {
      target.classList.remove('prd-EngravingLine_Value-active')
    }

    if (!target.value.match(this.regex)) {
      target.classList.add('prd-EngravingLine-error')
      if (!tooltip) {
        tooltip = document.createElement('span')
        tooltip.innerHTML = window.theme.strings.engraving.engraving_error
        tooltip.classList.add('prd-Engraving_Error', 'prd-EngravingLine_Error')
        e.target.parentElement.appendChild(tooltip)
      }
    } else {
      target.classList.remove('prd-EngravingLine-error')
      if (tooltip) {
        tooltip.remove()
      }
    }

    const count = target
      .closest('.prd-EngravingLine')
      .querySelector('[data-product-engraving-el="charCount"]')
    count.innerText = target.value.length

    this.updateOverlayText(parseInt(target.dataset.charmIndex))
  }

  updateOverlayText (charmIndex) {
    const lineEls = this.els.line.elements.filter(
      (lineEl) => lineEl.dataset.charmIndex === charmIndex.toString(),
    )
    const lines = this.els.line.elements.reduce(
      (val, el) => (el.value ? [...val, el.value] : val),
      [],
    )
    const engravingProps = this.engravingProps[charmIndex]
    const textContainers = this.textContainerGroups.map(
      (group) => group[charmIndex],
    )

    const submit = getElement('[data-product-add-to-cart]', { context: this })
    const itemAvailable = submit.dataset.available.toString() === 'true'

    textContainers.forEach((textContainer) => {
      textContainer.innerHTML = ''
    })
    if (!this.engravingEnabled) {
      submit.disabled = !itemAvailable
      return
    }
    if (!lines.join('').match(this.regex)) {
      submit.disabled = true
    } else {
      submit.disabled = !itemAvailable
    }

    let offset = 0

    textContainers.forEach((textContainer) => {
      // eslint-disable-next-line array-callback-return
      lineEls.map((lineEl, lineIndex) => {
        const lineContainer = document.createElementNS(this.svgNS, 'g')

        lineContainer.appendChild(
          this.createTextElement(lineEl.value, lineIndex, engravingProps),
        )
        lineContainer.appendChild(
          this.createTextElement(lineEl.value, lineIndex, engravingProps),
        )

        textContainer.appendChild(lineContainer)
      })

      if (textContainer.getBoundingClientRect().height > 0) {
        const ratio =
          400 / textContainer.closest('svg').getBoundingClientRect().height
        offset = (textContainer.getBoundingClientRect().height * ratio) / 2
      }
    })

    textContainers.forEach((textContainer) => {
      textContainer.setAttribute('transform', `translate(0, -${offset})`)
      textContainer.style.transform = engravingProps.r
      textContainer.style.transformOrigin = '50% 50%'
    })
  }

  createTextElement (text, index, engravingProps) {
    const { x, y, fs } = engravingProps

    const txt = document.createElementNS(this.svgNS, 'text')
    txt.setAttribute('x', 0)
    txt.setAttribute('x', x)
    txt.setAttribute('y', y + fs * index)
    txt.setAttribute('font-size', fs)
    txt.setAttribute('dominant-baseline', 'middle')
    txt.setAttribute('text-anchor', 'middle')
    txt.classList.add('prd-Engraving_OverlayText')
    txt.innerHTML = text

    return txt
  }

  formSubmit (e) {
    this.toggleFormErrors(false)

    if (this.engravingEnabled && this.els.text.element.ariaHidden !== 'true') {
      if (!this.checkLineValues) {
        e.preventDefault()
        e.stopPropagation()
        return false
      }
    }
  }

  toggleFormError (show, charmIndex) {
    const error = this.els.formError.elements.find(
      (formErrorEl) => formErrorEl.dataset.charmIndex === charmIndex,
    )
    if (error) {
      error.style.display = show ? 'block' : 'none'
    }
  }

  toggleFormErrors (show) {
    // eslint-disable-next-line array-callback-return
    this.els.formError.elements.map((formErrorEl) => {
      formErrorEl.style.display = show ? 'block' : 'none'
    })
  }

  get checkLineValues () {
    const charmValues = this.els.line.elements.reduce((val, el) => {
      const charmIndex = el.dataset.charmIndex
      val[charmIndex] = `${val[charmIndex] || ''}${el.value}`
      return val
    }, {})

    let charmsHaveValue = true

    // eslint-disable-next-line array-callback-return
    Object.keys(charmValues).map((key) => {
      if (!charmValues[key]) {
        charmsHaveValue = false
        this.toggleFormError(true, key)
        getElement('[key="engraving"]').scrollTo({
          top: 0,
          behavior: 'smooth',
        })
      }
    })

    return charmsHaveValue
  }

  get engravingEnabled () {
    return this.els.available.element.value === 'true'
  }
}

if (!customElements.get('product-engraving')) {
  customElements.define('product-engraving', ProductEngraving)
}
